<template>
  <div class="create-form" v-if="loaded">
    <InputDetail style="width: 100%" label="Name"
                 placeholder="Kundenname | Webseite | Kanal + Produkt | Laufzeit"
                 :value="localValue.name" @input="nameChanged"></InputDetail>
    <div class="split-div">
      <InputDetail style="width: 45%" label="DMP-ID" placeholder="..." :value="localValue.dmp_pixel"
                   @input="dmpPixelChanged"></InputDetail>
      <InputDetail style="width: 45%" label="Kontrollgruppen-ID" placeholder="seg1,seg2,seg3"
                   :value="localValue.segment_id"
                   @input="segmentIdChanged"></InputDetail>
    </div>
    <div class="split-div">
      <InputDetail label="TV-Segment" style="width: 45%"
                   placeholder="seg1,seg2,seg3"
                   :value="localValue.tv_segment" @input="tvSegmentChanged"></InputDetail>
      <InputDetail label="App-Segment" style="width: 45%"
                   placeholder="seg1,seg2,seg3"
                   :value="localValue.app_segment" @input="appSegmentChanged"></InputDetail>
    </div>
    <div class="split-div">
      <div style="width: 45%;position: relative"
           v-tooltip="'Die Verzögerung in Stunden, bevor der Nutzer nach der Markierung die Umfrage ausgespielt bekommt.'">
        <InputDetail label="Auslieferungsverzögerung (in Stunden)" placeholder="1"
                     :value="localValue.delivery_delay" @input="deliveryDelayChanged"></InputDetail>
        <span style="position: absolute;right: 5px;top: 5px" class="icon icon-info"></span>
      </div>
      <div style="width: 45%;position: relative"
           v-tooltip="'Die Gruppengröße für die Test- und Kontrollgruppe'">
        <InputDetail label="Gruppengröße" placeholder="300"
                     :value="localValue.test_size" @input="testSizeChanged">
        </InputDetail>
        <span style="position: absolute;right: 5px;top: 5px" class="icon icon-info"></span>
      </div>
    </div>
    <DatePicker :date_start="localValue.date_start" :date_end="localValue.date_end" style="width: 45%"
                @close="setDates"></DatePicker>
    <div>
      <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
        <div style="position:relative;"
             v-tooltip="'Soll nach zwei Mal Nein abgebrochen werden? Standard=abbrechen, Custom=weiter (Bei multiple Choice immer auf Custom setzen.)'">
          <div>Variante?</div>
          <span style="position: absolute;right: -25px;top: 0" class="icon icon-info"></span>
        </div>
        <fieldset>
          <input :disabled="multipleChoiceActive" type="radio" id="tc1" name="Termination" :value="1"
                 v-model="localValue.termination_criteria">
          <label for="tc1">Standard</label>
          <input :disabled="multipleChoiceActive" type="radio" id="tc2" name="Termination" :value="0"
                 v-model="localValue.termination_criteria">
          <label for="tc2">Custom</label>
        </fieldset>
      </div>
    </div>
    <div>
      <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
        <div style="position:relative;"
             v-tooltip="'Soll es eine Nullte Frage geben, bei der das generelle Interesse des Befragten evaluiert wird?'">
          <div>Interessensabfrage?</div>
          <span style="position: absolute; right: -25px;top: 0" class="icon icon-info"></span>
        </div>
        <fieldset>
          <input type="radio" id="ia1" name="it" :value="1"
                 v-model="localValue.interest_query" @change="interestQueryChanged">
          <label for="ia1"> Ja</label>
          <input type="radio" id="ia2" name="it" :value="0"
                 v-model="localValue.interest_query" @change="interestQueryChanged">
          <label for="ia2"> Nein</label>
        </fieldset>
      </div>
    </div>
    <InputDetail style="width: 100%" label="Marke" placeholder="Marke..." :value="localValue.brand"
                 @input="brandChanged"></InputDetail>
    <template v-for="(question, index) of localValue.questions">
      <QuestionBuilder @delete="deleteQuestion(index)" :minimize="question.minimize"
                       v-model="localValue.questions[index]"
                       :disable-social-question="isSocialQuestionDisabled(index)"
                       :hide-delete="index === 0 && localValue.interest_query" :brand="localValue.brand"
                       :disabled="question.disabled" v-bind:key="index"></QuestionBuilder>
    </template>
    <AdaButton style="width: 250px" title="Frage hinzufügen" @click="addQuestion" type="createButton"
               icon="icon-add"></AdaButton>
  </div>
</template>

<script>

import AdaButton from "./AdaButton";
import QuestionBuilder from "./QuestionBuilder";
import InputDetail from "./InputDetail";
import DatePicker from "./DatePicker";
import {RepositoryFactory} from "../scripts/RepositoryFactory";

const AdManagerRepository = RepositoryFactory.get('adManager');

export default {
  name: "SurveyForm",
  components: {
    AdaButton,
    QuestionBuilder,
    InputDetail,
    DatePicker
  },
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  data: function () {
    return {
      minimizeData: false,
      timer: null,
      loaded: false,
      dates: {
        start: '',
        end: ''
      },
      multipleChoiceActive: false,
      localValue: JSON.parse(JSON.stringify(this.value)),
      skipEmit: false
    }
  },
  mounted() {
    this.minimizeData = this.minimize;
    this.dates.start = this.localValue.date_start;
    this.dates.end = this.localValue.date_end;
    this.setDisabled();
    this.setMultipleChoiceActivation(this.localValue.questions);
    this.loaded = true;
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.skipEmit = true;
        this.localValue = JSON.parse(JSON.stringify(newVal));
        this.$nextTick(() => {
          this.skipEmit = false;
        });
      }
    },
    localValue: {
      deep: true,
      handler() {
        if (this.skipEmit) return;
        this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
      }
    },
    dates: {
      deep: true,
      handler() {
        this.localValue.date_start = this.dates.start;
        this.localValue.date_end = this.dates.end;
      }
    },
    'localValue.questions': {
      deep: true,
      handler(newVal) {
        this.setMultipleChoiceActivation(newVal);
      }
    }
  },
  methods: {
    isSocialQuestionDisabled(index) {
      if (this.localValue.questions.length - 1 === index) return false;
      return !(this.localValue.questions.length > index + 1 && this.localValue.questions[index + 1].social_question);
    },
    interestQueryChanged() {
      console.log(this.localValue.interest_query);
      if (this.localValue.interest_query) {
        this.localValue.questions.unshift({
          text: 'Wie sehr interessieren Sie sich für ...?',
          multiple_choice: false,
          social_question: false,
          answers: [
            {
              text: 'sehr'
            },
            {
              text: 'etwas'
            },
            {
              text: 'wenig'
            },
            {
              text: 'überhaupt nicht'
            }
          ],
          minimize: true,
          disabled: false,
          interest_query: true
        })
      } else {
        this.localValue.questions.shift();
      }
    },
    setMultipleChoiceActivation(questions) {
      let multipleChoiceActive = false;
      questions.forEach((q, index) => {
        // only consider the first 4 questions for this condition
        if (q.multiple_choice && index <= 3) {
          this.localValue.termination_criteria = 0;
          multipleChoiceActive = true;
        }
      });
      this.multipleChoiceActive = multipleChoiceActive;
    },
    setQuestionsDisabled(disabled) {
      this.localValue.questions.forEach(q => {
        q.disabled = disabled;
      })
    },
    testSizeChanged(testSize) {
      this.localValue.test_size = testSize;
    },
    deliveryDelayChanged(deliveryDelay) {
      this.localValue.delivery_delay = deliveryDelay;
    },
    setDisabled() {
      this.localValue.questions.forEach((question, index) => {
        if (index <= 3) {
          question.minimize = true;
        }
      })
    },
    nameChanged(name) {
      this.localValue.name = name;
    },
    orderIdChanged(orderId) {
      this.localValue.order_id = orderId;
      clearTimeout(this.timer);
      this.timer = null;
      if (this.localValue.order_id.length > 6) {
        this.timer = setTimeout(() => {
          this.updateOrderName();
        }, 800);
      }
    },
    async updateOrderName() {
      try {
        const {data} = await AdManagerRepository.getOneOrder(this.localValue.order_id);
        this.localValue.order_name = data.order.name;
      } catch (e) {
        console.error(e);
        this.localValue.order_name = 'not found';
      }
    },
    creativesChanged(creativesString) {
      this.localValue.creatives = creativesString;
    },
    cgCreativesChanged(creativesString) {
      this.localValue.cg_creatives = creativesString;
    },
    dmpPixelChanged(dmpPixel) {
      this.localValue.dmp_pixel = dmpPixel;
    },
    segmentIdChanged(segmentId) {
      this.localValue.segment_id = segmentId.replace(/ /g, '');
    },
    tvSegmentChanged(tvSegment) {
      this.localValue.tv_segment = tvSegment.replace(/ /g, '');
    },
    appSegmentChanged(appSegment) {
      this.localValue.app_segment = appSegment.replace(/ /g, '');
    },
    brandChanged(brand) {
      let old = '[' + this.localValue.brand + ']';
      this.localValue.brand = brand;
      let newVal = '[' + this.localValue.brand + ']';
      if (old === '[]' && this.localValue.brand !== '') {
        old = '[Brand]';
      }
      if (old !== '[]' && this.localValue.brand === '') {
        newVal = '[Brand]';
      }
      for (let i = 0; i < this.localValue.questions.length; i++) {
        if (typeof this.localValue.questions[i].text !== 'undefined') {
          this.localValue.questions[i].text = this.localValue.questions[i].text.replace(old, newVal);
        }
      }
    },
    addQuestion() {
      this.localValue.questions.push({
        question: '',
        answers: [
          {
            text: ''
          },
          {
            text: ''
          }
        ],
        multiple_choice: false,
        social_question: false
      })
    },
    deleteQuestion(index) {
      this.localValue.questions.splice(index, 1);
    },
    setDates(range) {
      this.localValue.date_start = range.start;
      this.localValue.date_end = range.end;
    }
  }
}
</script>

<style scoped>

fieldset {
  display: flex;
  flex-direction: row;
}

.create-form {
  width: 600px;
}

.create-form > div {
  margin-bottom: 20px;
}

.split-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.answer-container > input {
  width: 45%;
  margin-bottom: 8px;
}

</style>